import React from 'react';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { testAttributes } from './Constants';
import {
    paginationComponent,
} from './Pagination.module.scss';

const Pagination = ({ 
    breakLabel = '...', 
    pageCount, 
    handleClick, 
    pageRangeDisplayed = 5, 
    marginPagesDisplayed = 1, 
    nextLabel = <ArrowForwardIosIcon />, 
    previousLabel = <ArrowBackIosIcon />, 
    defaultPage = 0,
    ...rest
}) =>
    (
        <div data-testid={testAttributes.PAGINATION_CONTAINER} className={paginationComponent}>
            <ReactPaginate 
                breakLabel={breakLabel}
                pageCount={pageCount}
                pageRangeDisplayed={pageRangeDisplayed}
                marginPagesDisplayed={marginPagesDisplayed}
                containerClassName="paginationContainer"
                onPageChange={handleClick}
                previousLabel={previousLabel}
                nextLabel={nextLabel}
                forcePage={defaultPage}
                {...rest}
            />
        </div>
    );


Pagination.propTypes = {
    /** pageCount: Required. The total number of pages. */
    pageCount: PropTypes.number.isRequired,
    /** pageCount: Label for ellipsis. */
    breakLabel: PropTypes.string,
    /** handleClick: The method to call when a page is changed. */
    handleClick: PropTypes.func.isRequired,
    /** pageRangeDisplayed: The range of pages displayed.  */
    pageRangeDisplayed: PropTypes.number,
    /** marginPagesDisplayed: The number of pages to display for margins. */
    marginPagesDisplayed: PropTypes.number,
    /** nextLabel: Label for the next button. */
    nextLabel: PropTypes.element,
    /** previousLabel: Label for the next button. */
    previousLabel: PropTypes.element,
    /** defaultPage:  To override selected page with parent prop */
    defaultPage: PropTypes.number,
    /** rest: Any other props to pass to the component. */
    rest: PropTypes.object,
};

export default Pagination;